/// arwa code
import React, { useRef, useState, useCallback, useEffect } from "react";
import {
  HtmlEditor,
  Toolbar,
  Item,
  MediaResizing,
  ImageUpload,
} from "devextreme-react/html-editor";
import "../customHtmlEditor/CustomHtmlEditor.scss";

const CustomHtmlEditor = ({ markup, setMarkup }) => {
  const fileInputRef = useRef(null);
  const [buttonClicked, setButtonClicked] = useState(false);

  // Use a callback to prevent re-renders during button click
  const handleButtonClick = useCallback(() => {
    setButtonClicked(true); // Set state to trigger file input click
  }, []);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileName = file.name;
      setMarkup((prevMarkup) => `${prevMarkup}\nUploaded File: ${fileName}`);
    }
  };

  // Trigger the file input click after the component mounts to avoid re-renders
  useEffect(() => {
    if (buttonClicked && fileInputRef.current) {
      fileInputRef.current.click(); // Trigger file input click
      setButtonClicked(false); // Reset button click state
    }
  }, [buttonClicked]);

  return (
    <>
      <HtmlEditor
        // height="400px"
        className="myeditor"
        value={markup}
        onValueChanged={(e) => setMarkup(e.value)}
      >
        <MediaResizing enabled={true} />
        <ImageUpload tabs={["file", "url"]} fileUploadMode="base64" />
        <Toolbar>
          {/* <Item
            widget="dxButton"
            cssClass="addFileItem"
            onClick={handleButtonClick} // Memoized callback
          /> */}
          <Item name="bold" />
          <Item name="italic" />
          <Item name="underline" />
          <Item name="link" />
          <Item name="bulletList" />
          <Item name="orderedList" />
          {/* <Item name="image" /> */}
          <Item name="codeBlock" />
        </Toolbar>
      </HtmlEditor>

      <input
        ref={fileInputRef}
        type="file"
        style={{ display: "none" }}
        onChange={handleFileUpload}
      />
    </>
  );
};

export default CustomHtmlEditor;
